import { makeStyles, createStyles } from "@material-ui/core/styles";
import { tokens } from "../../../theme/tokens";

export const useFieldResourceStyles = makeStyles((theme) =>
  createStyles({
    fieldResourceContainer: {
      minHeight: "650px",
      maxHeight: "650px",
      width: "103%",
      paddingRight: "5px",
      scrollbarGutter: "auto",
      overflowX: "hidden",
      overflowY: "hidden",
      "&:hover": {
        overflowY: "scroll",
      },
    },
    emptyFieldResourceContainer: {
      backgroundColor: tokens.color.surface.sunken,
      minHeight: "650px",
      maxHeight: "650px",
      borderRadius: tokens.radius.md,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    tabHeading: {
      color: tokens.color.text.primary,
      fontSize: "1em",
      marginLeft: "0.5em",
    },
    leftInformationDiv: {
      backgroundColor: tokens.color.surface.default,
      width: "auto",
      borderRadius: tokens.radius.md,
      border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
      boxShadow: "none",
      marginBottom: "10px",
      "&.MuiAccordion-rounded:first-child": {
        borderRadius: `${tokens.radius.md} !important`,
      },
    },
    cardContentContainer: {
      display: "flex",
      flexDirection: "column",
      gap: tokens.space[1],
      width: "100%",
      minWidth: 0,
    },
    label: {
      fontSize: tokens.type.caption.size,
      fontWeight: tokens.type.denseStrong.weight,
      lineHeight: tokens.type.caption.lineHeight,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      color: tokens.color.text.secondary,
    },
    // formikInput: {
    //   color: theme.palette.primary.main,
    //   fontSize: "1em",
    //   marginLeft: "1vh",
    //   width: "50%",
    //   textAlign: "right",
    //   "& .MuiInputBase-input": {
    //     textAlign: "right",
    //   },
    //   "& ::-webkit-calendar-picker-indicator": {
    //     marginLeft: "0px",
    //   },
    // },
    infoContainer: {
      width: "95%",
      margin: "5px auto 5px",
      padding: "10px 0 10px 0",
      display: "flex",
      rowGap: "14px",
      flexDirection: "column",
    },
    labelContainer: {
      flex: "1",
      alignItems: "center",
    },
    localFieldResourceAddBtn: {
      marginTop: "auto",
      backgroundColor: theme.palette.primary.main,
      fontFamily: tokens.type.family,
      fontSize: "1em",
      color: tokens.color.brand.onPrimary,
      textTransform: "inherit",
      borderRadius: tokens.radius.sm,
      boxShadow: "none",
      textAlign: "center",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        opacity: "0.8",
      },
    },
    btn: {
      marginTop: "auto",
      fontFamily: tokens.type.family,
      fontSize: "1em",
      textTransform: "inherit",
      borderRadius: tokens.radius.sm,
      boxShadow: "none",
      textAlign: "center",
      padding: "8px",
      "&:hover": {
        backgroundColor: tokens.color.brand.primaryActionHover,
        opacity: "0.8",
        boxShadow: "none",
        color: tokens.color.brand.onPrimary,
      },
    },
    bottomButtonRow: {
      display: "flex",
      justifyContent: "space-between",
      margin: "0 10px 10px 0",
    },
    expandIconButton: {
      padding: "5px !important",
    },
    removeIconButton: {
      fontSize: "1em",
      borderRadius: tokens.radius.sm,
      textAlign: "center",
      padding: "5px",
      marginLeft: "1%",
    },
  })
);
